import { useUploadDamageExceptionAttachment } from '@/api/DamageExceptions';
import { ImageModel } from '@/types';
import { GalleryImages, UploadButton } from '@/ui/components';
import { Divider, Empty, Space } from 'antd';
import React, { FC } from 'react';

interface ImagesProps {
  damageExceptionId: number;
  images: ImageModel[];
  attachments: ImageModel[];
}
export const Images: FC<ImagesProps> = ({
  damageExceptionId,
  images,
  attachments,
}) => {
  const { mutateAsync: uploadAsync } =
    useUploadDamageExceptionAttachment(damageExceptionId);

  const onGetBase64 = async (base64String: string, fileName: string) => {
    await uploadAsync({
      damageExceptionId,
      fileName,
      fileBase64: base64String,
    });
  };

  return (
    <>
      <Divider>Images</Divider>
      <Space className="w-100" direction="vertical">
        <div>Original Images</div>
        {images.length > 0 ? (
          <div style={{ height: 200 }} className="w-100">
            <GalleryImages
              actions={{ download: true }}
              images={images.map((image) => ({
                imageFileUrl: image.url,
                thumbnailImageUrl: image.resizedImageUrl,
              }))}
            />
          </div>
        ) : (
          <Empty />
        )}

        <div className="d-flex align-items-center justify-content-between">
          Attachments
          <UploadButton
            tooltip="Click to upload attachment"
            className="m-1"
            onGetBase64={onGetBase64}
          />
        </div>
        {attachments.length > 0 ? (
          <div style={{ height: 200 }} className="w-100">
            <GalleryImages
              actions={{ download: true }}
              images={attachments.map((image) => ({
                imageFileUrl: image.url,
                thumbnailImageUrl: image.resizedImageUrl,
              }))}
            />
          </div>
        ) : (
          <Empty />
        )}
      </Space>
    </>
  );
};
